<template>
  <v-app>
    <spinner />

    <router-view />

    <bottom-nav v-show="bottomNav" />

    <!-- [모달] 신청서 뷰어 -->
    <application-viewer-dialog />
  </v-app>
</template>

<script>
import Spinner from '@/components/common/Spinner.vue'; // 스피너 컴포넌트
import ApplicationViewerDialog from '@/components/application/dialog/ApplicationViewerDialog.vue';
import BottomNav from '@/components/common/BottomNav.vue';
import { postNewSession } from '@/api/auth';
//import { langStorage } from '@/plugins/locales';
//import { loadLocale } from '@/plugins/locales'; //다국어 ejkim

export default {
  name: 'App',
  data: () => ({
    testData: '',
  }),
  // watch: {
  //   '$i18n.locale'(lang) {
  //     loadLocale.set(lang);
  //     this.$router.push({ name: 'main' });
  //   },
  // },
  computed: {
    bottomNav() {
      const bottomNavFlag = this.$route.meta.bottomNav;
      return bottomNavFlag !== undefined && bottomNavFlag;
    },
  },
  methods: {
    /* 세션정보 갱신 및 반환 */
    async saveNewSession() {
      try {
        const newSessionRes = await postNewSession();
        const newSessionData = newSessionRes.data.data;
        console.log(newSessionData);
        this.toMain();
      } catch (error) {
        alert(error);
      }
    },

    /* 메인으로 이동 */
    toMain() {
      this.$store.commit('SPINNER/ON_COMMON_SPINNER');
      this.$router.replace('/main');
    },
  },
  components: { Spinner, ApplicationViewerDialog, BottomNav },
  created() {
    /*
     * 쿠키없을때 validateSession 호출 callback
     * 앱에서 가져온 데이터로 쿠키 셋팅
     */
    window.afterValidateSession = event => {
      try {
        const returnData = JSON.parse(event).afterValidateSession;
        const userData = returnData.contextData;
        if (process.env.NODE_ENV === 'development') {
          this.$store.commit('setUserData', userData);
          this.$store.commit('setToken', userData);
        }

        // 쿠키 없는 상태, api 호출시 헤더에 담을 토큰 셋팅
        this.$store.commit('setTokenObj', userData);

        // 세션정보 갱신 및 반환
        this.saveNewSession();
      } catch (error) {
        alert('#mobile - !error afterValidateSession ' + error);
      }
    };
  },
};
</script>
